import React from "react";
import{CardDivBody} from './styles';



const CardBody= ({children,  ...rest }) => {

  return (
    <CardDivBody {...rest}>
      {children}
    </CardDivBody>
  );
}

export default CardBody;
